import { Text } from '@user-portal/wikr-components';

import { selectCurrentUser } from 'store/user/selectors';

import { useSelector } from 'hooks/store';

import ProfileTab from 'components/ProfileTab';
import SettingsTab from 'components/SettingsTab';
import SubscriptionsTab from 'components/SubscriptionsTab';
import { Tabs } from 'components/Tabs';

import MaleAvatar from 'assets/images/avatar.svg';
import FemaleAvatar from 'assets/img/svg/avatarWoman.svg';

import { accountTabs, TABS } from './constants';

import * as S from './styled';

interface IAccountSettings {
    tabId?: string;
    onChangeTab: (tabId: string) => void;
}

const getCurrentTab = (currentTab: string) => {
    switch (currentTab) {
        case accountTabs.Subscription:
            return <SubscriptionsTab />;

        case accountTabs.Settings:
            return <SettingsTab />;

        default:
            return <ProfileTab />;
    }
};

const AccountSettings = ({ tabId, onChangeTab }: IAccountSettings) => {
    const currentUser = useSelector(selectCurrentUser);
    const currentTabId = tabId || accountTabs.Profile;

    return (
        <>
            <S.Container>
                {currentUser?.name && currentUser?.last_name && (
                    <S.AvatarWrapper $paddingTop={48} $paddingBottom={16} $paddingX={16}>
                        {currentUser?.gender === 'female' ? <FemaleAvatar /> : <MaleAvatar />}
                        <Text type="h5">{`${currentUser.name} ${currentUser.last_name}`}</Text>
                    </S.AvatarWrapper>
                )}
                <S.ContentWrapper>
                    <Tabs tabs={TABS} currentTab={currentTabId} onChange={onChangeTab} />
                </S.ContentWrapper>
            </S.Container>
            <S.ContentWrapper $paddingX={16}>{getCurrentTab(currentTabId)}</S.ContentWrapper>
        </>
    );
};

export default AccountSettings;
